import { render } from "./Colaboradores.vue?vue&type=template&id=8d0623a4"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"

import "./Colaboradores.vue?vue&type=style&index=0&id=8d0623a4&lang=scss&scopes=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__